import type { Context } from 'react';
import { createContext } from 'react';

import type { DirectoryInvitePeopleSource } from '@atlassian/ptc-embeddable-directory';
import type { InviteeListOption, BulkInviteResponse } from '@atlassian/invite-people/types';

import type { UserRole } from './types.ts';
import type { CoreInvitesSource } from './constants.ts';

export type CoreInvitesCallbacks = {
	onModalClosed?: () => void;
	onInviteCompleted?: (result?: BulkInviteResponse) => void;
	getContextualInviteNudgeProps?: () => {
		showSpotlight: boolean;
	};
};

export type OpenCoreInvitesFunction = (
	touchPoint?: CoreInvitesSource | DirectoryInvitePeopleSource,
	callbacks?: CoreInvitesCallbacks,
	invitees?: InviteeListOption[],
	productContextMetadata?: Record<string, string>,
) => void;

export type CoreInvitesContextType = {
	openCoreInvites?: OpenCoreInvitesFunction;
	userRole?: UserRole;
};

export const CoreInvitesContext: Context<CoreInvitesContextType> =
	createContext<CoreInvitesContextType>({});
